import { render, staticRenderFns } from "./CommonDropdown.vue?vue&type=template&id=bb6b3b0e"
import script from "./CommonDropdown.vue?vue&type=script&lang=js"
export * from "./CommonDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports